// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".с-message-template-compliance-error-box{margin-top:16px}.с-message-template-compliance-error-box--animation-enter{-webkit-transform:translateY(50px);transform:translateY(50px)}.с-message-template-compliance-error-box--animation-enter-active{-webkit-transform:translateY(0px);transform:translateY(0px);transition:-webkit-transform 300ms;transition:transform 300ms;transition:transform 300ms, -webkit-transform 300ms}", ""]);
// Exports
module.exports = exports;
